import React, { Component } from 'react';
import { compose } from 'redux';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { connect } from 'react-redux';

import Select from './Select';
import { bookingFormInitialValues } from '../store/reducers';
import { setStep } from '../store/actions';
import BoardBases from './BoardBases/index';
import SelectedRooms from './SelectedRooms/index';
import faUmbrella from '@fortawesome/fontawesome-pro-light/faUmbrella';
import faUtensils from '@fortawesome/fontawesome-pro-light/faUtensils';
import StayType from '../enums/StayType';
import { getBoardBaseOptions } from '../apiHelpers';
import withLocalize from '../withLocalize';

class Step2 extends Component {

	componentWillMount() {
		this.props.dispatch(setStep(2));
	}

	render() {
		const { boardBaseByGuestType, boardBases, formValues, translate: t, translateSelectOptions } = this.props;
		const boardBaseOptions = getBoardBaseOptions(boardBases, formValues.currency);

		return (
			<div className="container">
				<SelectedRooms/>

				<div className="select-row">
					<Field
						component={Select}
						name="stayType"
						label={t('Step2.stayType')}
						className="select-row__item"
						fontAwesomeIcon={faUmbrella}
						options={translateSelectOptions(StayType.getOptions())}
					/>

					{!boardBaseByGuestType && boardBaseOptions.length > 1 &&
					<Field
						component={Select}
						name="boardBase"
						label={t('Step2.boardBase')}
						className="select-row__item"
						fontAwesomeIcon={faUtensils}
						options={boardBaseOptions}
					/>
					}
				</div>

				{boardBaseByGuestType && boardBaseOptions.length > 1 &&
				<BoardBases/>
				}
			</div>
		);
	}
}

export default compose(
	reduxForm({
		form: 'bookingForm',
		initialValues: bookingFormInitialValues,
		destroyOnUnmount: false,
	}),
	connect((state) => ({
		formValues: getFormValues('bookingForm')(state),
		boardBaseByGuestType: state.app.boardBaseByGuestType,
		boardBases: state.app.boardBases,
	})),
	withLocalize,
)(Step2);



// WEBPACK FOOTER //
// ./src/components/Step2.jsx